import { BaseModel, Attribute } from './base-model'

export class StaticContent extends BaseModel {
  public id       : number
  public videoId  : number
  public name: string
  public fileUrl: string
}



// WEBPACK FOOTER //
// ./src/models/static-content.ts